









import Vue from 'vue';
import CompareToolbar from './CompareToolbar.vue';
import CompareParameter from './CompareParameter.vue';
import ProductModel from '../productDetail/ProductModel.vue';

export default Vue.extend({
    components: {
        CompareToolbar,
    },
    data() {
        return {
            active: 0,
            content: CompareParameter,
            items: [
                {
                    name: '参数', path: 'parameter', content: CompareParameter, icon: 'iconicon_duibi_canshu',
                },
                {
                    name: '模型', path: 'model', content: ProductModel, icon: 'iconicon_duibi_moxin',
                },
                {
                    name: '图纸', path: 'drawing', content: ProductModel, icon: 'iconicon_duibi_tuzhi',
                },
            ],
        };
    },
    computed: {
        reloadVs(): boolean {
            return this.$store.state.reloadVs;
        },
    },
    watch: {
        $route(to) {
            if (to.fullPath.indexOf('drawing') > -1 && this.active !== 2) {
                this.select(2);
            } else if (to.fullPath.indexOf('model') > -1 && this.active !== 1) {
                this.select(1);
            }
        },
        reloadVs(val) {
            if (val) {
                if (this.active === 0) (this.content as any) = '';
                this.select(this.active);
                setTimeout(() => {
                    this.$store.commit('reloadVs', false);
                }, 20);
            }
        },
    },
    mounted() {
        const idx = this.items.findIndex((e) => e.path === this.$route.params.type);
        if (idx) {
            (this.content as any) = this.items[idx].content;
            this.active = idx;
        }
    },
    methods: {
        select(idx) {
            this.active = idx;
            if (idx === 1 || idx === 2) {
                (this.content as any) = '';
                this.$store.commit('mainSearchbar', false);
                this.$store.commit('hideSearchBar');
            }
            if (idx === 0) {
                this.$store.commit('mainSearchbar', true);
                this.$store.commit('showSearchBar');
            }
            if (this.items[idx].content) {
                setTimeout(() => {
                    (this.content as any) = this.items[idx].content;
                }, 20);
                if (this.$route.fullPath.indexOf(this.items[idx].path) === -1) {
                    this.$router.push({
                        path: `/compare/${this.items[idx].path}`,
                    });
                }
            }
        },
    },
    beforeDestroy() {
        this.$store.commit('mainSearchbar', true);
        this.$store.commit('showSearchBar');
    },
});
